export const ONE_S_IN_MS = 1000;

export const BASE_REFETCH_TIME_MS = 5000;

export const CONTRAST_THRESHOLD = 4.5;

export const THEME_NAMES = {
  PurpleDash: "Purple Dash",
  InfuseClassic: "INFUSE Classic",
  GoldenRush: "Golden Rush",
  Retro: "Retro Red",
  Halloween: "Hello, Ween",
};
